export const MuiTypography = {
  h1: {
    fontSize: '32px',
    fontWeight: '700',
  },
  h5: {
    fontSize: '14px',
    fontWeight: '500',
  },
  h6: {
    fontSize: '14px',
    fontWeight: '600',
  },
  subtitle1: {
    fontSize: '14px',
    fontWeight: '400',
  },
  body2: {
    fontSize: '12px',
    fontWeight: '400',
  },
};
